import React, { Component } from "react";
import { connect } from "react-redux";
import * as am4core from "@amcharts/amcharts4/core";
import * as am4charts from "@amcharts/amcharts4/charts";
import am4themes_animated from "@amcharts/amcharts4/themes/animated";
import containsLongRunningProcess from "components/hoc/containsLongRunningProcess";
import { getTrainingCompletenessStats } from "actions";
import * as Alerts from "components/elements/alerts";
import { Trans } from "react-i18next";
import i18next from "i18next";

am4core.useTheme(am4themes_animated);

class TrainingCompleteness extends Component {
  state = {
    statsFetched: false,
    isManager: localStorage.getItem("roles").includes("Manager"),
    error: null,
    selectedDepartment: { value: 0, label: i18next.t(10046) },
    selectedDepartmentEmployeeQualification: 0,
    selectedDepartmentDealerQualification: 0,
    selectedDepartmentTotalQualification: 0,
  };

  chartDiv = React.createRef();
  bbgv = React.createRef();
  bbgv2 = React.createRef();
  bbgv3 = React.createRef();
  deptSelectCombo = React.createRef();
  chart = null;
  chartCreated = false;
  unsuccessColor = "#e42c3b";
  averageColor = "#ff7f00";
  successColor = "#09b409";

  componentDidMount() {
    this.fetchStats();
  }

  fetchStats = () => {
    this.props.getTrainingCompletenessStats(
      this.onBegin,
      this.onSuccess,
      this.onError
    );
  };

  componentDidUpdate(prevProps, prevStats) {
    if (this.state.statsFetched) {
      this.trainingCompletenessChart();
      this.chartCreated = true;
    }
  }

  componentWillUnmount() {
    if (this.chart) {
      this.chart.dispose();
    }
  }

  onBegin = () => {
    this.props.onProcessBegin();
  };

  onError = (err) => {
    console.log(err);
    this.props.onProcessEnd();
    this.setState({ statsFetched: false, error: err.message });
  };

  onSuccess = (res) => {
    this.props.onProcessEnd();
    this.setState({
      statsFetched: true,
      selectedDepartment: { value: 0, label: i18next.t(10046) },
      selectedDepartmentEmployeeQualification: this.props.stats
        .employeeQualification,
      selectedDepartmentDealerQualification: this.props.stats
        .dealerQualification,
      selectedDepartmentTotalQualification:
        this.props.stats.totalQualificationAverage ?? 0,
    });
  };

  getColorCode(subj) {
    if (subj < 50) {
      return this.unsuccessColor;
    } else if (subj >= 50 && subj < 85) {
      return this.averageColor;
    } else {
      return this.successColor;
    }
  }

  trainingCompletenessChart = () => {
    if (this.chart) {
      this.chart.dispose();
    }

    let kvArray = [
      Number(this.state.selectedDepartmentEmployeeQualification.toFixed(1)),
      // Number(this.state.selectedDepartmentDealerQualification.toFixed(1)),
      // Number(this.state.selectedDepartmentTotalQualification.toFixed(1)),
    ];
    kvArray.sort(function (a, b) {
      return b - a;
    });

    // this.bbgv3.current.style.backgroundColor = "#af46d1";
    // this.bbgv3.current.style.width = `${this.state.selectedDepartmentTotalQualification}%`;
    // this.bbgv3.current.style.zIndex = kvArray.indexOf(
    //   this.state.selectedDepartmentTotalQualification
    // );
    // this.bbgv2.current.style.backgroundColor = "#2d98d5";
    // this.bbgv2.current.style.width = `${this.state.selectedDepartmentDealerQualification}%`;
    // this.bbgv2.current.style.zIndex = kvArray.indexOf(
    //   this.state.selectedDepartmentDealerQualification
    // );

    this.bbgv.current.style.backgroundColor = this.getColorCode(
      this.state.selectedDepartmentEmployeeQualification
    );
    this.bbgv.current.style.width = `${this.state.selectedDepartmentEmployeeQualification}%`;
    this.bbgv.current.style.zIndex = kvArray.indexOf(
      this.state.selectedDepartmentEmployeeQualification
    );

    am4core.useTheme(am4themes_animated);
    // create chart
    this.chart = am4core.create(this.chartDiv.current, am4charts.GaugeChart);
    this.chart.innerRadius = am4core.percent(72);
    this.chart.paddingTop = am4core.percent(0);
    this.chart.paddingLeft = am4core.percent(0);
    this.chart.paddingRight = am4core.percent(0);
    this.chart.paddingBottom = am4core.percent(0);

    let axisChart2 = this.chart.xAxes.push(new am4charts.ValueAxis());
    axisChart2.min = 0;
    axisChart2.max = 100;
    axisChart2.renderer.innerRadius = 10;
    axisChart2.strictMinMax = true;
    axisChart2.renderer.labels.template.disabled = true;
    axisChart2.renderer.ticks.template.disabled = true;
    axisChart2.renderer.grid.template.disabled = true;

    let chart2range0 = axisChart2.axisRanges.create();
    chart2range0.value = 0;
    chart2range0.endValue = 100;
    chart2range0.axisFill.fillOpacity = 1;
    chart2range0.axisFill.fill = am4core.color(
      this.getColorCode(this.state.selectedDepartmentEmployeeQualification)
    );
    chart2range0.axisFill.radius = am4core.percent(100);
    chart2range0.axisFill.innerRadius = am4core.percent(60); // set it to >100 if you'd like to have some gap between fills
    chart2range0.grid.disabled = true;

    let chart2range1 = axisChart2.axisRanges.create();
    chart2range1.value = 0;
    chart2range1.endValue = 100;
    chart2range1.axisFill.fillOpacity = 1;
    chart2range1.axisFill.fill = am4core.color("#DADADA");
    chart2range1.axisFill.radius = am4core.percent(100);
    chart2range1.axisFill.innerRadius = am4core.percent(60); // set it to >100 if you'd like to have some gap between fills
    chart2range1.grid.disabled = true;

    let axis2Chart2 = this.chart.xAxes.push(new am4charts.ValueAxis());
    axis2Chart2.min = 0;
    axis2Chart2.max = 100;
    axis2Chart2.strictMinMax = true;
    axis2Chart2.renderer.labels.template.disabled = true;
    axis2Chart2.renderer.ticks.template.disabled = true;
    axis2Chart2.renderer.grid.template.disabled = true;

    // let chart2range4 = axis2Chart2.axisRanges.create();
    // chart2range4.value = 0;
    // chart2range4.endValue = 100;
    // chart2range4.axisFill.fillOpacity = 1;
    // chart2range4.axisFill.fill = am4core.color("#DADADA");
    // chart2range4.axisFill.radius = am4core.percent(117);
    // chart2range4.axisFill.innerRadius = am4core.percent(110); // set it to >100 if you'd like to have some gap between fills
    // chart2range4.grid.disabled = true;

    // let chart2range2 = axis2Chart2.axisRanges.create();
    // chart2range2.value = 0;
    // chart2range2.endValue = 100;
    // chart2range2.axisFill.fillOpacity = 1;
    // chart2range2.axisFill.fill = am4core.color("#b45dd1");
    // chart2range2.axisFill.radius = am4core.percent(117);
    // chart2range2.axisFill.innerRadius = am4core.percent(110); // set it to >100 if you'd like to have some gap between fills
    // chart2range2.grid.disabled = true;

    // let chart2range3 = axis2Chart2.axisRanges.create();
    // chart2range3.value = 0;
    // chart2range3.endValue = 100;
    // chart2range3.axisFill.fillOpacity = 1;
    // chart2range3.axisFill.fill = am4core.color("#2d98d5");
    // chart2range3.axisFill.radius = am4core.percent(117);
    // chart2range3.axisFill.innerRadius = am4core.percent(110); // set it to >100 if you'd like to have some gap between fills
    // chart2range3.grid.disabled = true;

    let hand = this.chart.hands.push(new am4charts.ClockHand());
    hand.axis = axisChart2;
    hand.innerRadius = am4core.percent(10);
    hand.startWidth = 0;
    hand.pin.disabled = true;
    hand.value = 0;
    hand.opacity = 0;

    // let hand2 = this.chart.hands.push(new am4charts.ClockHand());
    // hand2.axis = axisChart2;
    // hand2.innerRadius = am4core.percent(10);
    // hand2.startWidth = 0;
    // hand2.pin.disabled = true;
    // hand2.value = 0;
    // hand2.opacity = 0;

    // let hand3 = this.chart.hands.push(new am4charts.ClockHand());
    // hand3.axis = axisChart2;
    // hand3.innerRadius = am4core.percent(10);
    // hand3.startWidth = 0;
    // hand3.pin.disabled = true;
    // hand3.value = 0;
    // hand3.opacity = 0;

    hand.events.on("propertychanged", function (ev) {
      chart2range0.endValue = ev.target.value;
      chart2range1.value = ev.target.value;
    });
    // let drt = this.state.selectedDepartmentDealerQualification; // h2
    // let dct = this.state.selectedDepartmentTotalQualification; // h3

    // hand2.events.on("propertychanged", function (ev) {
    //   chart2range3.value = drt > dct ? dct : 0;
    //   chart2range3.endValue = ev.target.value;
    // });
    // hand3.events.on("propertychanged", function (ev) {
    //   chart2range2.value = dct >= drt ? drt : 0;
    //   chart2range2.endValue = ev.target.value;
    // });
    new am4core.Animation(
      hand,
      {
        property: "value",
        to: this.state.selectedDepartmentEmployeeQualification,
      },
      1500
    ).start();
    // new am4core.Animation(
    //   hand2,
    //   {
    //     property: "value",
    //     to: this.state.selectedDepartmentDealerQualification,
    //   },
    //   1500
    // ).start();
    // new am4core.Animation(
    //   hand3,
    //   {
    //     property: "value",
    //     to: this.state.selectedDepartmentTotalQualification,
    //   },
    //   1500
    // ).start();
  };

  showCombo = () => {
    let combo = this.deptSelectCombo.current;
    combo.classList.toggle("open");
  };

  handleDepartmentSelect = (value, label) => {
    if (value === 0) {
      this.setState({
        selectedDepartment: { value: value, label: label },
        selectedDepartmentEmployeeQualification: this.props.stats
          .employeeQualification,
        selectedDepartmentDealerQualification: this.props.stats
          .dealerQualification,
        selectedDepartmentTotalQualification: this.props.stats
          .totalQualificationAverage,
      });
    } else {
      this.setState({
        selectedDepartment: { value: value, label: label },
        selectedDepartmentEmployeeQualification: this.props.stats
          .employeeQualification,
        selectedDepartmentDealerQualification: this.props.stats.items.find(
          (d) => d.serviceType.value === value
        ).dealerQualification,
        selectedDepartmentTotalQualification: this.props.stats.items.find(
          (d) => d.serviceType.value === value
        ).countryQualification,
      });
    }
  };

  getQualClassName = (qual) => {
    if (parseInt(qual) < 50) return "red";
    else if (qual >= 50 && qual < 85) return "orange";
    else return "green";
  };

  renderStats = () => {
    if (this.state.statsFetched) {
      return (
        <div className="tamamlananEgitimAlani tumDepartmanlarPDH">
          <div
            className={`egitimSayisi ${this.getQualClassName(
              this.state.selectedDepartmentEmployeeQualification
            )}`}
          >
            <sup>%</sup>
            {this.state.selectedDepartmentEmployeeQualification}
          </div>
          <div
            id="tripleChartBuildPDH_2"
            className="chartGraphic"
            ref={this.chartDiv}
          ></div>
          <div className="satisSonrasiOrani">
            {/* <div className="axis2range" style={{ color: "#2d98d5" }}>
              <sup>%</sup>
              {this.state.selectedDepartmentDealerQualification}
            </div>
            <div className="axis2range" style={{ color: "#af46d1" }}>
              <sup>%</sup>
              {this.state.selectedDepartmentTotalQualification}
            </div> */}
          </div>
          <div className="clearfix"></div>
          <div className="borderBottomGraphicBg">
            <div className="borderBottomGraphicValue1" ref={this.bbgv}></div>
            {/* <div className="borderBottomGraphicValue2" ref={this.bbgv2}></div>
            <div
              className="borderBottomGraphicValue3"
              ref={this.bbgv3}
              style={{ background: "#af46d1" }}
            ></div> */}
          </div>
          <ul className="infoText">
            <li className={`${this.getQualClassName(
              this.state.selectedDepartmentEmployeeQualification
            )}`}>
              <div className={`bullet bg-${this.getQualClassName(
                this.state.selectedDepartmentEmployeeQualification
              )}`}></div>{" "}
              <Trans desc="Bireysel">10518</Trans>
            </li>
            {/* <li className="blue">
              <div className="bullet bg-blue"></div>{" "}
              {this.state.selectedDepartment.value === 0 ? (
                <Trans desc="Tüm Departmantlar">10046</Trans>
              ) : (
                this.state.selectedDepartment.label
              )}
              {" | "} <Trans desc="Bayi">10391</Trans>
            </li>
            <li className="purple">
              <div className="bullet bg-purple"></div>
              <Trans desc="Türkiye Ortalaması">10052</Trans>
            </li> */}
          </ul>
        </div>
      );
    } else if (this.state.error !== null) {
      return (
        <div style={{ width: "80%", margin: "auto" }}>
          {Alerts.RedAlert({ content: this.state.error })}
        </div>
      );
    } else {
      return this.props.spinner;
    }
  };

  renderDepartmentCombo = () => {
    if (!this.state.statsFetched) {
      return null;
    }

    if (!this.state.isManager) return null;
    else {
      return (
        <div className="departmanSecimAlani">
          <div className="custom-select-wrapper" id="departmanSecenekleriTC">
            <div
              className="custom-select departmanSecenekleriSecili"
              ref={this.deptSelectCombo}
              onClick={this.showCombo}
            >
              <div className="custom-select__trigger">
                <span>
                  {this.state.selectedDepartment.value !== 0 ? (
                    this.state.selectedDepartment.label + " "
                  ) : (
                    <>
                      <Trans desc="Tüm Departmantlar">10046</Trans>
                      <span>&nbsp;</span>
                    </>
                  )}
                </span>
                <span className="iconmford fo-icon-expand-more"></span>
              </div>
              <div
                className="custom-options departmanSecenekleriTC graphicTCoptions"
                data-id="0"
              >
                <span
                  className="custom-option etoGraphTypeYonetim graphicTC selected"
                  data-value="all"
                  onClick={() => this.handleDepartmentSelect(0, i18next.t(10046))}
                >
                  <Trans desc="Tüm Departmanlar">10046</Trans>
                </span>
                <span
                  className="custom-option etoGraphTypeYonetim graphicTC"
                  onClick={() =>
                    this.handleDepartmentSelect(50022, i18next.t(10047))
                  }
                >
                  <Trans desc="Satış">10047</Trans>
                </span>
                <span
                  className="custom-option etoGraphTypeYonetim graphicTC"
                  onClick={() =>
                    this.handleDepartmentSelect(50000, i18next.t(10612))
                  }
                >
                  <Trans desc="Satış Sonrası">10612</Trans>
                </span>
                <span
                  className="custom-option etoGraphTypeYonetim graphicTC"
                  onClick={() =>
                    this.handleDepartmentSelect(50023, i18next.t(10048))
                  }
                >
                  <Trans desc="Servis İdari">10048</Trans>
                </span>
                <span
                  className="custom-option etoGraphTypeYonetim graphicTC"
                  onClick={() =>
                    this.handleDepartmentSelect(50020, i18next.t(10049))
                  }
                >
                  <Trans desc="Mekanik">10049</Trans>
                </span>
                <span
                  className="custom-option etoGraphTypeYonetim graphicTC"
                  onClick={() =>
                    this.handleDepartmentSelect(50021, i18next.t(10050))
                  }
                >
                  <Trans desc="Kaporta/Boya">10050</Trans>
                </span>
              </div>
            </div>
          </div>
        </div>
      );
    }
  };

  render() {
    return (
      <div className="egitimTamamlanmaOrani">
        <div className="dashboardHeader">
          <div className="dashboardHeaderContent">
            <div className="egitimBaslik">
              <Trans desc="Eğitim Tamamlanma Oranı">10009</Trans>
            </div>
            {/* {this.renderDepartmentCombo()} */}
          </div>
        </div>
        <hr />
        {this.renderStats()}
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    stats: state.stats.trainingCompleteness,
    application: state.application,
  };
};

export default connect(mapStateToProps, { getTrainingCompletenessStats })(
  containsLongRunningProcess(TrainingCompleteness)
);
